import api from "./api";

export const putMyBankAccount = async (id, data) => {
  return api
    .put({
      endpoint: `/bank-account/${id}`,
      port: process.env.REACT_APP_PORT_VENUE,
      body: data
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
